export const WINDOW_TYPE = Object.freeze({
  CABINET: 'cabinet',
  CASHBOX: 'cashbox',
  MOBILE_WP: 'mobile_wp',
  STAND: 'stand',
  TABLE: 'table',
  WINDOW: 'window'
});

export const WINDOW_TYPE_TRANSLATIONS = Object.freeze({
  [WINDOW_TYPE.CABINET]: 'window_type_cabinet',
  [WINDOW_TYPE.CASHBOX]: 'window_type_cashbox',
  [WINDOW_TYPE.STAND]: 'window_type_stand',
  [WINDOW_TYPE.TABLE]: 'window_type_table',
  [WINDOW_TYPE.WINDOW]: 'window_type_window',
  [WINDOW_TYPE.MOBILE_WP]: 'window_type_mobile_wp',
});
